var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleError = function SvgCircleError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 11.2954C6.98047 11.0142 7.08008 10.7779 7.2793 10.5865C7.47852 10.3951 7.71875 10.2993 8 10.2993C8.30078 10.2993 8.54492 10.3951 8.73242 10.5865C8.92383 10.774 9.01953 11.0103 9.01953 11.2954C9.01953 11.5884 8.92578 11.8286 8.73828 12.0161C8.55078 12.1997 8.30469 12.2915 8 12.2915C7.71484 12.2915 7.47266 12.1978 7.27344 12.0103C7.07812 11.8228 6.98047 11.5845 6.98047 11.2954ZM7.0625 6.87747V3.73099H8.96094V6.87747L8.55078 9.62552H7.47266L7.0625 6.87747Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-error.77ce1c0bd1aaa770cea3981a78394f04.svg";